import React, { useState } from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { useEffect } from 'react';
import { Clear } from '@material-ui/icons';
import ProviderRequestService from 'services/provider-request';
import Dropzone from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import style from './style.module.scss';

const ProviderDocuments = ({documents,setDocuments,documentsRemove,setDocumentsRemove,edit}) => {
  const { t } = useTranslation();
  const [selectCategories, setSelectCategories] = useState([]);

  const renderDocuments = () => {
    const getType = (k) => {
      if(getValue('category_id',k)){
        let type = selectCategories.length>0?selectCategories.filter(a=>a.id == getValue('category_id',k))[0].type:'';
        switch (type) {
          case 'arquivo':
            return ( <Form.Group>
              <Form.Label>Arquivo</Form.Label>
              <Dropzone
                multiple={false}
                onDrop={acceptedFiles => {
                  let file = (acceptedFiles.length !== 0?acceptedFiles[0]:null);
                  setValue('doc',k,file);
                }}
              >
              {({
              getRootProps,
              getInputProps,
              isDragActive,
              isDragAccept,
              isDragReject
            }) => (
              <section>
                <div
                  {...getRootProps({
                    className:
                      style.dropzone +
                      (isDragActive ? ' active' : '') +
                      (isDragAccept ? ' accept' : '') +
                      (isDragReject ? ' reject' : '')
                  })}
                >
                  <input {...getInputProps()} />
                  {getValue('doc',k)?getValue('doc',k).name:<>
                    {!isDragActive ? (
                      <span>{t('label:drag here')}</span>
                    ) : isDragAccept ? (
                      <span>{t('label:drop now')}</span>
                    ) : (
                      <span>{t('label:file not accepted')}</span>
                    )}
                  </>}
                </div>
              </section>
            )}
              </Dropzone>
            </Form.Group>
            );
            break;
          case 'link':
            return (<>
            <Form.Label>Link</Form.Label>
            <Form.Control
              required
              type="text"
              value={getValue('doc',k)}
              onChange={(e) => setValue('doc',k,e.target.value)}
            />
            </>);
            break;
          default:
            break;
        }
      }
      return <></>;
    };

    const getValue = (name,k) => {
      let d = documents[k];
      if(d && d[name]) return d[name];
      return '';
    };

    const setValue = (name,k,value) => {
      let d = [...documents].map((a,i)=>{
        if(k===i) a[name] = value;
        return a;
      });
      setDocuments([...d]);
    };

    const renderDocument = (document,k) => {
      return <Col xs="12" className="row" key={k} style={{ alignItems: 'center'}}>
        <Col md='4'>
          <Form.Group>
            <Form.Label>Categoria</Form.Label>
            <Form.Control
              required
              as="select"
              value={getValue('category_id',k)}
              onChange={(e) => {
                setValue('category_id',k,e.target.value);
                setValue('doc',k,null);
                let type = selectCategories.filter(a=>a.id == e.target.value)[0].type;
                setValue('type',k,type);
              }}
              disabled={getValue('url_document',k) || !edit}
            >
              <option value="" disabled={true}>Selecione</option>
              {selectCategories.map((a)=>{
                return <option value={a.id} key={a.id}>{a.name}</option>
              })}
            </Form.Control>
          </Form.Group>
        </Col>
        <Col md='4'>
          <Form.Group>
            <Form.Label>Nome</Form.Label>
            <Form.Control
              required
              type="text"
              value={getValue('name',k)}
              onChange={(e) => setValue('name',k,e.target.value)}
              disabled={!getValue('category_id',k) || getValue('url_document',k) || !edit}
            />
          </Form.Group>
        </Col>
        {getValue('url_document',k)?(<>
        <Col>
          <Form.Group>
            <Form.Label>{selectCategories.length>0 && selectCategories.filter(a=>a.id == getValue('category_id',k))[0].type === 'arquivo'?'Arquivo':'Link'}</Form.Label>
            <a href={getValue('url_document',k)} target="_blank" className='a-document-link'><Form.Control plaintext readOnly defaultValue={getValue('document_name',k)?getValue('document_name',k):'Link'} /></a>
          </Form.Group>
        </Col>
        {edit?(<>
        <Col xs="auto">
          <Button size="sm" variant="danger" className="mt-3" onClick={() => {
            setDocumentsRemove([...documentsRemove, documents[k].id]);
            setDocuments([...documents.filter((a,i)=>{
              return k !== i;
            })])
          }}>
            <Clear />
          </Button>
        </Col>
        </>):(<></>)}
        </>):(<>
        <Col>
        {getType(k)}
        </Col>
        
        {edit?(<>
        <Col xs="auto">
          <Button size="sm" variant="danger" className="mt-3" onClick={() => {
            setDocumentsRemove([...documentsRemove, documents[k].id]);
            setDocuments([...documents.filter((a,i)=>{
              return k !== i;
            })])
          }}>
            <Clear />
          </Button>
        </Col>
        </>):(<></>)}
        </>)}
      </Col>
    };
  
    return <>{documents.map((a,k)=>{
      return renderDocument(a,k);
    })}</>;
  };

  useEffect(() => {
    ProviderRequestService.getDocumentCategories().then(data=>{
      setSelectCategories(data.data);
    });
  },[])

  return (
  <>
    <Row className="mb-3">
      <Col md="12">
        <h6 className="title-dashboard">Documentos</h6>
      </Col>
      <Col md="12">
        <hr className="line"></hr>
      </Col>
    </Row>
    <Row>
      {renderDocuments()}
    </Row>
    {edit?<>
    <Row className="mb-3">
      <Col xs="auto">
        <Button block variant="primary" onClick={()=>
          setDocuments([...documents, {}])
        }>
          Adicionar Documento
        </Button>
      </Col>
    </Row>
    </>:<></>}
  </>
  );
}


export default ProviderDocuments;